import { QueryFactory } from "../../../../Common";
export const QPersonalizedEvents = QueryFactory("PersonalizedEvents");
//# sourceMappingURL=QPersonalizedEvents.js.map